import {NgModule} from "@angular/core";
import {CommonModule} from "@angular/common";
import {visbosTouchClientRouting, visbosTouchClientRoutingProviders} from "./visbos-touch-client.routes";
import {VisbosTouchClientComponent} from "./visbos-touch-client.component";
import {TouchNavigationMenuComponent} from "./ui/navigation/touch-navigation-menu/touch-navigation-menu.component";
import {TouchScanComponent} from "./ui/touch-scan/touch-scan.component";
import {IdentityModule} from "../identity/identity.module";
import {TabsModule} from "ngx-bootstrap";
import {ScanConsumerComponent} from "./ui/touch-scan/scan-consumer/scan-consumer.component";
import {ScanStocksComponent} from "./ui/touch-scan/scan-stocks/scan-stocks.component";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {MissionModule} from "../mission/mission.module";
import {StoreManagementModule} from "../store-management/store-management.module";
import {VisbosCoreModule} from "../core/visbos-core/visbos-core.module";
import {TouchNavbarComponent} from "./ui/navigation/touch-navbar/touch-navbar.component";
import {TieredMenuModule} from "primeng/components/tieredmenu/tieredmenu";
import {InplaceModule} from "primeng/primeng";
import {TouchDepotYardSearchComponent} from "./ui/touch-depot-yard-search/touch-depot-yard-search.component";
import {ManualWarehousingComponent} from './ui/touch-warehousing/manual-warehousing/manual-warehousing.component';
import {ManualWarehousingDataComponent} from './ui/touch-warehousing/components/manual-warehousing-data/manual-warehousing-data.component';
import {ManualWarehousingArticlesComponent} from './ui/touch-warehousing/components/manual-warehousing-articles/manual-warehousing-articles.component';
import {ArchwizardModule} from "ng2-archwizard/dist";
import {TouchFillUpDepotSelectionComponent} from './ui/touch-fill-up/touch-fill-up-depot-selection/touch-fill-up-depot-selection.component';
import {TouchFillUpWizardComponent} from './ui/touch-fill-up/touch-fill-up-wizard/touch-fill-up-wizard.component';
import {RedirectToVtouchComponent} from './ui/vtouch/redirect-to-vtouch/redirect-to-vtouch.component';
import {TouchMenuService} from "./ui/navigation/touch-menu.service";
import {StocktakingWizardComponent} from './ui/touch-stocktaking/stocktaking-wizard/stocktaking-wizard.component';
import {TouchInitMedicineStocktakingComponent} from './ui/touch-stocktaking/touch-init-medicine-stocktaking/touch-init-medicine-stocktaking.component';
import {TouchStocktakingMenuComponent} from './ui/touch-stocktaking/touch-stocktaking-menu/touch-stocktaking-menu.component';
import {TouchMenuComponent} from './ui/navigation/touch-menu/touch-menu.component';
import {TouchStocktakingService} from "./ui/touch-stocktaking/touch-stocktaking.service";
import {CarouselModule} from 'ngx-bootstrap/carousel';
import { TouchDepotNeedsWizardComponent } from './ui/touch-depot-needs/touch-depot-needs-wizard/touch-depot-needs-wizard.component';
import { TouchDepotNeedsDepotSelectionComponent } from './ui/touch-depot-needs/touch-depot-needs-depot-selection/touch-depot-needs-depot-selection.component';
import { TouchAssetStatusComponent } from './ui/touch-asset-status/touch-asset-status.component';
import { TouchMarriageWizzardComponent } from './ui/touch-marriage/touch-marriage-wizzard/touch-marriage-wizzard.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    visbosTouchClientRouting,
    IdentityModule,
    MissionModule,
    VisbosCoreModule,
    StoreManagementModule,
    TabsModule.forRoot(),
    TieredMenuModule,
    InplaceModule,
    ArchwizardModule,
    CarouselModule.forRoot()
  ],
  providers: [visbosTouchClientRoutingProviders, TouchMenuService, TouchStocktakingService],
  declarations: [VisbosTouchClientComponent, TouchNavigationMenuComponent, TouchScanComponent, ScanConsumerComponent, ScanStocksComponent, TouchNavbarComponent, TouchDepotYardSearchComponent, ManualWarehousingComponent, ManualWarehousingDataComponent, ManualWarehousingArticlesComponent, TouchFillUpDepotSelectionComponent, TouchFillUpWizardComponent, RedirectToVtouchComponent, StocktakingWizardComponent, TouchInitMedicineStocktakingComponent, TouchStocktakingMenuComponent, TouchMenuComponent, TouchDepotNeedsWizardComponent, TouchDepotNeedsDepotSelectionComponent, TouchAssetStatusComponent, TouchMarriageWizzardComponent]
})
export class VisbosTouchClientModule {
}



// WEBPACK FOOTER //
// ./src/app/visbos-touch-client/visbos-touch-client.module.ts